import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { PersonaSummaryDto } from '@models/persona/personaSummaryDto.mode';
import { PersonaService } from '@services/persona/persona.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { isFalsy } from 'utility-types';
import { AccionesDialog } from '@models/base/identificadores.model';
import { Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogDeletePersonaComponent } from '../dialog-delete-persona/dialog-delete-persona.component';
import { FormPersonaReactiveComponent } from '../form-persona-reactive/form-persona-reactive.component';
import { PersonaDto } from '@models/persona/personaDto.model';
import { PersonaDetailDto } from '@models/persona/personaDetailDto.model';
import { PersonaFilter } from '@models/persona/personaFilter.model';
import { TipoDocumentoService } from '@services/tipoDocumento/tipoDocumento.service';
import { TipoDocumentoDto } from '@models/tipoDocumento/tipoDocumentoDto.model';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { EtiquetasPipe } from '@pipes/etiquetas.pipe';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { AvatarInicialesComponent } from 'src/app/component/avatar-iniciales/avatar-iniciales.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonFilterTableClearComponent } from 'src/app/component/button-filter-table-clear/button-filter-table-clear.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { DialogEditInputComponent } from 'src/app/component/dialog-edit-input-correo/dialog-edit-input-correo.component';
import { BtnNuevaPersonaComponent } from '../btn-nueva-persona/btn-nueva-persona.component';
import { DialogFormPersonaComponent } from '../dialog-form-persona/dialog-form-persona.component';
import { DialogParams } from '@interfaces/dialogParam.interface.model';

@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule, AppRolesDirective, MatTooltipModule, MatSortModule,
    MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, MatNativeDateModule, MatSelectModule, MatRadioModule, A11yModule, MatCheckboxModule, RouterModule, ButtonFilterTableClearComponent, ButtonNewComponent,
  ],
  selector: 'app-listado-personas',
  templateUrl: './listado-personas.component.html',
  styleUrls: ['./listado-personas.component.css']
})
export class ListadoPersonasComponent implements OnInit {
  data = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<PersonaDto>()
  lstPersonaDto!: PersonaDto[]
  formBuilder: FormBuilder = new FormBuilder;
  formFilter: FormGroup;
  lstTiposDocumento!: TipoDocumentoDto[];
  accionesDialog = AccionesDialog;

  constructor(
    private personaService: PersonaService,
    private tipoDocumentoService: TipoDocumentoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["nombreCompleto", "accion"] :
        ["nombreCompleto", "documento", "correo", "estados", "accion"];
    });

    this.formFilter = this.formBuilder.group({
      Activo: [true],
      Nombre: [''],
      Apellido: [''],
      NroDocumento: [''],
      IdTipoDocumento: [''],
      Correo: [''],
    })

    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'nombreCompleto':
          return item.nombreCompleto ?? ''; // Maneja null/undefined

        case 'documento':
          return item.nroDocumento?.toLowerCase?.() ?? '';

        case 'correo':
          return item.correo?.toLowerCase?.() ?? '';

        default:
          return typeof item[property] === 'string'
            ? item[property].toLowerCase()
            : item[property] ?? '';
      }
    };
  }


  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  ngOnInit(): void {
    this.getAllTiposDocumento();

    const filtroPersonaGuardado = localStorage.getItem('filtroPersonaGuardado');
    if (filtroPersonaGuardado) {
      const filtro: PersonaFilter = JSON.parse(filtroPersonaGuardado);
      this.formFilter.patchValue(filtro);
    }
  }

  applyFilter(event: any) {
    if (event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  filtrosAvanzados(event: any) { }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  getAllPersonas() {
    this.spinner.show('spListado')
    this.personaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spListado');
          this.dataSource.data = data.sort((a, b) => a.nombreCompleto.toString().localeCompare(b.nombreCompleto.toString())) as PersonaDto[]
          this.lstPersonaDto = this.dataSource.data
          this.data = this.dataSource.data.length >= 1 ? true : false

          let estado = this.formFilter.controls["TiposEstado"].value
          this.filterTiposEstado(estado)
        },
        error => {
          this.spinner.hide('spListado');
          this.snackBar.showError(error, "Error");
        })
  }

  getAllPersonasByFilter(personaFilter: PersonaFilter) {
    this.spinner.show('spListado')
    this.personaService.getAllPersonasByFilter(personaFilter)
      .subscribe(
        data => {
          this.spinner.hide('spListado');
          this.dataSource.data = data.sort((a, b) => a.nombreCompleto.toString().localeCompare(b.nombreCompleto.toString())) as PersonaDto[]
          this.lstPersonaDto = this.dataSource.data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spListado');
          this.snackBar.showError(error, "Error");
        })
  }

  getAllTiposDocumento() {
    this.spinner.show('spBusquedaTipoDoc')
    this.tipoDocumentoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spBusquedaTipoDoc');
          this.lstTiposDocumento = data
        },
        error => {
          this.spinner.hide('spBusquedaTipoDoc');
          this.snackBar.showError(error, "Error");
        })
  }

  abrirDialogoCorreo(persona: any): void {
    const dialogRef = this.dialog.open(DialogEditInputComponent, {
      width: "25%",
      data: { correo: persona.correo }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        persona.correo = result;
        // podés guardar el cambio en el backend si querés
      }
    });
  }

  filterTiposEstado(event: string) {
    // this.dataSource.data = this.personas
    switch (event) {
      case "Todos":
        break;
      case "Activos":
        this.dataSource.data = this.dataSource.data.filter(x => x.activo == true)
        break;
      case "Baja":
        this.dataSource.data = this.dataSource.data.filter(x => x.activo == false)
        break;
      default:
        break;
    }
  }


  aplicarFiltro(personaFilter: PersonaFilter = this.formFilter.value) {

    this.getAllPersonasByFilter(personaFilter)
    this.guardarFiltro();
  }

  guardarFiltro() {
    const filtro: PersonaFilter = this.formFilter.value;
    localStorage.setItem('filtroPersonaGuardado', JSON.stringify(filtro));
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroPersonaGuardado');
  }

  editarPersona(personaDto: PersonaDto) {
    this.router.navigate(["/personas/edit/" + personaDto.id])
  }

  reactivar(personaDto: PersonaDto): void {
    let personaDetailDto = new PersonaDetailDto
    personaDetailDto.id = personaDto.id
    personaDetailDto.nombre = personaDto.nombre
    personaDetailDto.apellido = personaDto.apellido
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = personaDetailDto

    const dialogRef = this.dialog.open(FormPersonaReactiveComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Eliminar) {
        this.aplicarFiltro()
      }
    });
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "50%"
        break;

      default:
        dialogConfig.width = "80%"
        break;
    }
    dialogConfig.data = data

    const dialogRef = this.dialog.open(DialogFormPersonaComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }


  isFalsy(valor: any) {
    return isFalsy(valor)
  }


}
